import React from 'react';
import { FiClock, FiDollarSign, FiLayers, FiRefreshCw, FiShield, FiLifeBuoy } from 'react-icons/fi';

const MvpWhyChooseUs = () => {
    const features = [
        {
            id: 1,
            icon: <FiClock size={24} />,
            title: "Speed to Market", 
            desc: "Our streamlined development process gets your product in front of real users in as little as 6-8 weeks — no long roadmaps, no wasted cycles.",
        },
        {
            id: 2,
            icon: <FiDollarSign size={24} />,
            title: "Budget-Friendly",
            desc: "We prioritise essential features and strip out everything that doesn't add value, keeping your MVP cost-effective without cutting corners on quality."
        },
        {
            id: 3,
            icon: <FiLayers size={24} />,
            title: "Scalable Architecture",
            desc: "Every MVP we build is engineered to grow. When you're ready to scale, your codebase is already prepared for the next phase."
        },
        {
            id: 4,
            icon: <FiRefreshCw size={24} />,
            title: "Agile & Iterative",
            desc: "We work in short sprints with regular check-ins, so you stay in control and we can adapt quickly based on your feedback and market signals."
        },
        {
            id: 5,
            icon: <FiShield size={24} />,
            title: "Quality Assured",
            desc: "Even as an MVP, every feature is thoroughly tested. We ship products that work reliably and leave a strong first impression with your users."
        },
        {
            id: 6,
            icon: <FiLifeBuoy size={24} />,
            title: "Dedicated Support",
            desc: "We don't disappear after launch. Our team stays engaged to help you gather feedback, fix issues, and plan your next development milestone."
        }
    ];

    return (
        <div className="section section-padding mvp-why-choose-area">
            <div className="container">
                <div className="row justify-content-center text-center">
                    <div className="col-lg-8">
                        <h2 className="title mb-3 fw-bold" style={{fontSize: "36px"}}>
                            Why choose us for <span className="text-primary">MVP development?</span>
                        </h2>
                        <p className="subtitle mb-5 text-muted" style={{fontSize: "16px"}}>
                            We specialise in lean, effective MVPs that validate ideas and lay the foundation for successful products — on time and on budget.
                        </p>
                    </div>
                </div>

                <div className="row">
                    {features.map((item) => (
                        <div className="col-lg-4 col-md-6 col-6 mb-4 px-2" key={item.id}>
                            <div className="why-choose-card bg-white p-3 p-md-4 h-100 d-flex flex-column text-start rounded-4 shadow-sm border border-light">
                                <div className="icon-box mb-3 mb-md-4 d-inline-flex align-items-center justify-content-center text-primary bg-primary-light rounded-circle" style={{ width: "50px", height: "50px" }}>
                                    {item.icon}
                                </div>
                                <h4 className="title mb-2 mb-md-3 fw-bold text-dark" style={{fontSize: "calc(16px + 0.25vw)", lineHeight: "1.2"}}>{item.title}</h4>
                                <p className="desc text-muted mb-0 flex-grow-1" style={{fontSize: "calc(12px + 0.1vw)", lineHeight: "1.5"}}>
                                    {item.desc}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default MvpWhyChooseUs;
